import { getFileToken } from "@/interface/modules/upload.api"
import axios from 'axios'

export default {
    data () {
        return {
            queue: [],
            uploading: false
        }
    },
    methods: {
        filepath (file) {
            let url = null;
            if (window.createObjcectURL != undefined) {
                url = window.createOjcectURL(file)
            } else if (window.URL != undefined) {
                url = window.URL.createObjectURL(file)
            } else if (window.webkitURL != undefined) {
                url = window.webkitURL.createObjectURL(file)
            }
            return url
        },
        select (e) {
            const fileList = e.target.files
            const list = []
            for (let prop in fileList) {
                if (typeof fileList[prop] == 'object') list.push({
                    file: fileList[prop],
                    path: this.filepath(fileList[prop]),
                    result: null,
                    progress: 0,
                    uploaded: 'waiting'
                })
            }
            this.queue = Object.assign([], list)
            this.generate()
        },
        generate () {
            const that = this
            this.uploading = true
            getFileToken({
                data: {
                    count: this.queue.length,
                    category: 'preview'
                },
                success: tokens => {
                    for (let i = 0; i<tokens.length; i++) {
                        that.excute(i, tokens[i])
                    }
                }
            })
        },
        excute (index, token) {
            const that = this
            const file = this.queue[index].file
            let fileData = new window.FormData()
            fileData.append('file', file),
            fileData.append('token', token)
            axios.post('https://up-z0.qiniup.com', fileData, {
                onUploadProgress: e => {
                    that.queue[index].progress = Math.round((e.loaded * 100) / e.total)
                }
            }).then(res => {
                that.queue[index].result = res.data.result
                that.queue[index].uploaded = 'success'
                that.complete()
            }).catch(err => {
                that.queue[index].result = err
                that.queue[index].uploaded = 'fail'
                that.complete()
            })
        },
        complete () {
            let ifComplete = true
            for (let i=0; i < this.queue.length; i++) {
                // console.log(this.data.queue[i].status)
                if (this.queue[i].uploaded == 'waiting') ifComplete = false
            }
            if (ifComplete) {
                const files = this.queue.filter(file => file.uploaded == 'success').map(file => file.result.image)
                this.album = [...this.album, ...files]
                this.clear()
            }
        },
        clear () {
            this.queue = []
            const input = document.querySelector('#photo')
            input.value = ''
        }
    }
}